import * as Immutable from 'immutable';
import { ModuleTypes } from '../../_config/ModuleInfo';
import { IModuleStore } from '../../_stores/ModuleStore';

export interface IModuleChevronStore extends IModuleStore {
	angle: number,
	thickness1: number,
	color1: string,
	color2: string
}

const defaultStore = Immutable.Record<IModuleChevronStore>({
	name: undefined,
	type: ModuleTypes.Chevron,
	angle: 45,
	thickness1: 5,
	color1: 'rgba(0,0,0,1)',
	color2: 'rgba(0,0,0,1)',
});

export default class ModuleChevronStore extends defaultStore implements IModuleChevronStore {}